import { useState } from 'react';
import Image from '../../../atoms/Image';
import Text from '../../../atoms/Text';
import TokenInfo from '../../../molecules/TokenInfo';
import usdIcon from '../../../molecules/PairIcons/icons/USD.svg';
import { SEOStatisticsField } from '../Sidebar';
import NumberDisplay from '../../../molecules/NumberDisplay';

interface ISidebarProps {
  chain?: string;
  address?: string;
  priceUSD?: number;
  converterTitle?: string;
  statisticsTitle: string;
  slug: string;
  statistics: Record<string, SEOStatisticsField>;
}

const Sidebar = ({
  chain,
  address,
  converterTitle,
  statisticsTitle,
  slug,
  priceUSD,
  statistics,
}: ISidebarProps) => {
  const [tokenAmount, setTokenAmount] = useState(1);

  const hasPrice = priceUSD !== undefined;

  return (
    <>
      {hasPrice && (
        <div className='mobile_seo_page__converter'>
          <Text size={14} className='text--weight-600 text--grey-200'>
            {converterTitle}
          </Text>
          <div className='mobile_seo_page__converter__form'>
            <div className='mobile_seo_page__converter__field text--grey-200'>
              <div className='mobile_seo_page__converter__field__symbol'>
                <TokenInfo
                  chain={chain || ''}
                  address={address || ''}
                  name={slug}
                  imageSize='s'
                  textSize={14}
                  textWeight={500}
                />
              </div>
              <input
                type='number'
                className='field text--grey-400'
                value={tokenAmount.toString()}
                onChange={(e) => setTokenAmount(Number(e.target.value))}
              />
            </div>
            <div className='mobile_seo_page__converter__field text--grey-200'>
              {/* <div className='icon-chevron-down mobile_seo_page__converter__field__icon' /> */}
              <div className='mobile_seo_page__converter__field__symbol'>
                {/* <select className='mobile_seo_page__converter__field__select field text--grey-200'>
                  <option value='USD'>USD</option>
                </select> */}
                <div className='token_info'>
                  <Image
                    className='token_info__icon'
                    alt='USD'
                    src={usdIcon}
                    size='s'
                  />
                  <Text size={14} className='text--weight-500'>
                    USD
                  </Text>
                </div>
              </div>
              <NumberDisplay
                value={tokenAmount * priceUSD}
                startSymbol='$'
                textProps={{ size: 12, className: 'text--grey-400' }}
              />
            </div>
          </div>
          <Text size={12} className='text--weight-500 text--grey-600'>
            1 {slug} = <NumberDisplay value={priceUSD} startSymbol='$' string />
          </Text>
        </div>
      )}
      <div className='mobile_seo_page__statistics'>
        <div className='mobile_seo_page__statistics__title'>
          <Text size={18} className='text--weight-600 text--grey-200'>
            {statisticsTitle}
          </Text>
        </div>
        <div className='mobile_seo_page__statistics__info'>
          {Object.entries(statistics).map(([label, stat], index) => (
            <div
              key={index}
              className='mobile_seo_page__statistics__info__item'
            >
              <Text size={12} className='text--grey-400 text--weight-500'>
                {label}
              </Text>
              {stat.type === 'default' && (
                <Text size={12} className='text--grey-200 text--weight-500'>
                  {stat.value}
                </Text>
              )}
              {stat.type === 'price' && (
                <NumberDisplay
                  value={stat.value}
                  startSymbol='$'
                  textProps={{
                    size: 12,
                    className: 'text--grey-200 text--weight-500',
                  }}
                />
              )}
              {stat.type === 'complexPrice' && (
                <Text size={12} className='text--grey-200 text--weight-500'>
                  <NumberDisplay
                    value={stat.leftValue}
                    startSymbol='$'
                    string
                  />
                  &nbsp;
                  {stat.divider}
                  &nbsp;
                  <NumberDisplay
                    value={stat.rightValue}
                    startSymbol='$'
                    string
                  />
                </Text>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Sidebar;
